import { captureException } from "@sentry/react";
import type { AttachmentPicker } from "web_myplann/Shared/Types/AttachmentPicker";
import type { PickedAttachment } from "web_myplann/Shared/Types/PickedAttachment";
import { resolvePickedAttachment } from "web_myplann/Shared/Utils/resolvePickedAttachment";
import { AttachmentPickStatuses } from "web_myplann/Utils/WebViewModel";

export const runAttachmentPicker = async (
	picker: AttachmentPicker,
): Promise<PickedAttachment> => {
	try {
		const { payload } = await picker();

		return resolvePickedAttachment(payload);
	} catch (error) {
		captureException(error);

		return { status: AttachmentPickStatuses.error };
	}
};
